module.exports = __webpack_public_path__ + "img/icon-info-circle.78c79034.svg";